import sample from '@/data/sample-colors.json'
import type { RegistryColor } from './registry'

/**
 * Bundled sample of the registry (the 140 named colors as "reserved" plus a
 * handful of registered examples), used by src/lib/api.ts when /api is down.
 */
export const colors: RegistryColor[] = sample.colors as RegistryColor[]

export const registeredColors = colors.filter((c) => c.type !== 'reserved')

export function randomRegisteredColor(): RegistryColor {
  return registeredColors[Math.floor(Math.random() * registeredColors.length)]
}
